import React, { useEffect, useRef } from "react"
import * as Icons from "lucide-react"

export default function EmailContextMenu({
  x,
  y,
  message,
  folders,
  onClose,
  onReply,
  onReplyAll,
  onForward,
  onMarkRead,
  onMarkUnread,
  onStar,
  onFlag,
  onMove,
  onDelete,
  onArchive,
}) {
  const ref = useRef(null)

  useEffect(() => {
    const handleClick = e => {
      if (ref.current && !ref.current.contains(e.target)) onClose()
    }
    document.addEventListener("click", handleClick)
    return () => document.removeEventListener("click", handleClick)
  }, [onClose])

  const menuItems = [
    { label: "Reply", icon: Icons.Reply, action: () => onReply(message) },
    {
      label: "Reply All",
      icon: Icons.ReplyAll,
      action: () => onReplyAll(message),
    },
    { label: "Forward", icon: Icons.Forward, action: () => onForward(message) },
    { type: "divider" },
    {
      label: message.is_read ? "Mark as Unread" : "Mark as Read",
      icon: message.is_read ? Icons.Mail : Icons.MailOpen,
      action: () =>
        message.is_read ? onMarkUnread(message) : onMarkRead(message),
    },
    {
      label: message.is_starred ? "Unstar" : "Star",
      icon: Icons.Star,
      action: () => onStar(message),
    },
    {
      label: message.is_flagged ? "Unflag" : "Flag",
      icon: Icons.Flag,
      action: () => onFlag(message),
    },
    { type: "divider" },
    {
      label: "Archive",
      icon: Icons.Archive,
      action: () => onArchive(message),
    },
    ...(folders
      ? [
          {
            label: "Move to",
            icon: Icons.FolderInput,
            children: folders
              .filter(
                f =>
                  f.system_folder &&
                  !["trash", "junk", "drafts", "sent"].includes(f.system_folder)
              )
              .map(f => ({
                label: f.label || f.name,
                action: () => onMove(message, f.folder_id),
              })),
          },
        ]
      : []),
    { type: "divider" },
    {
      label: "Delete",
      icon: Icons.Trash2,
      action: () => onDelete(message),
      danger: true,
    },
  ]

  const menuWidth = 200
  const adjustedX = Math.min(x, window.innerWidth - menuWidth - 10)
  const adjustedY = Math.min(y, window.innerHeight - menuItems.length * 30 - 20)

  return (
    <div
      ref={ref}
      className="em-context-menu"
      style={{ left: adjustedX, top: adjustedY }}
    >
      {menuItems.map((item, i) => {
        if (item.type === "divider") {
          return <div key={i} className="em-context-menu-divider" />
        }
        if (item.children) {
          return (
            <div
              key={i}
              className="em-context-menu-item"
              style={{ justifyContent: "space-between" }}
            >
              <span>
                <item.icon size={14} style={{ marginRight: 8 }} />
                {item.label}
              </span>
              <Icons.ChevronRight size={12} />
            </div>
          )
        }
        return (
          <div
            key={i}
            className="em-context-menu-item"
            style={item.danger ? { color: "#d32f2f" } : {}}
            onClick={() => {
              item.action()
              onClose()
            }}
          >
            <item.icon size={14} />
            <span>{item.label}</span>
          </div>
        )
      })}
    </div>
  )
}
